import { decryptText, encryptText } from "./Encryption";

const TOKEN_STORAGE_KEY = "fleeiq_token";
const USER_STORAGE_KEY = "fleeiq_user";

const migrateLegacyStorage = () => {
  if (
    localStorage.getItem(TOKEN_STORAGE_KEY) ||
    localStorage.getItem(USER_STORAGE_KEY)
  ) {
    return;
  }

  const legacyTokenKeys = [];
  const legacyUserKeys = [];

  for (let key in localStorage) {
    if (!Object.prototype.hasOwnProperty.call(localStorage, key)) continue;
    const value = localStorage[key];
    if (!value) continue;
    const decryptedKey = decryptText(key);
    if (decryptedKey === "token") {
      legacyTokenKeys.push(key);
    } else if (decryptedKey === "user") {
      legacyUserKeys.push(key);
    }
  }

  if (legacyTokenKeys.length > 0) {
    localStorage.setItem(
      TOKEN_STORAGE_KEY,
      localStorage.getItem(legacyTokenKeys[0]),
    );
  }
  if (legacyUserKeys.length > 0) {
    localStorage.setItem(
      USER_STORAGE_KEY,
      localStorage.getItem(legacyUserKeys[0]),
    );
  }

  [...legacyTokenKeys, ...legacyUserKeys].forEach((key) =>
    localStorage.removeItem(key),
  );
};

const setStoredToken = (tokenObj) => {
  localStorage.setItem(
    TOKEN_STORAGE_KEY,
    encryptText(JSON.stringify(tokenObj)),
  );
};

const setStoredUser = (userObj) => {
  localStorage.setItem(USER_STORAGE_KEY, encryptText(JSON.stringify(userObj)));
};

const updateUserStates = (setUserData, setUserToken) => {
  migrateLegacyStorage();

  const obj = {};

  const rawUser = localStorage.getItem(USER_STORAGE_KEY);
  if (rawUser) {
    obj.user = JSON.parse(decryptText(rawUser));
  }

  const rawToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (rawToken) {
    obj.token = JSON.parse(decryptText(rawToken));
  }

  setUserData({
    ...obj.user,
    permissions: obj.user?.permissions || [],
  });

  setUserToken(obj.token);
  return obj;
};

const getToken = () => {
  const rawToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!rawToken) return undefined;
  return JSON.parse(decryptText(rawToken)).access;
};

const getRefreshToken = () => {
  const rawToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!rawToken) return undefined;
  return JSON.parse(decryptText(rawToken)).refresh;
};

const getUser = async () => {
  const rawUser = localStorage.getItem(USER_STORAGE_KEY);
  if (!rawUser) return undefined;
  return JSON.parse(decryptText(rawUser));
};

const handleLogout = (setUserData, setUserToken) => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
  setUserData({});
  setUserToken({ access: "", refresh: "" });
};

const handleUpdateUser = (setUserData, userData) => {
  setStoredUser(userData);
  setUserData(userData);
};

export {
  handleLogout,
  getToken,
  getUser,
  getRefreshToken,
  handleUpdateUser,
  setStoredToken,
  setStoredUser,
  TOKEN_STORAGE_KEY,
  USER_STORAGE_KEY,
};
export default updateUserStates;
